// extracted by mini-css-extract-plugin
export default {"tupacGrid":"ti-z","tupacHeader":"ui-z","tupacHeader2":"vi-z","tupacMenu":"wi-z","tupacMenu2":"xi-z","tupacMain":"yi-z","tupacMain2":"zi-z"};